import { Theme } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import { stylesConstants } from '../../styles/stylesConstants';

export default makeStyles((theme: Theme) => ({
  container: {
    borderRadius: theme.spacing(1),
    // overflow: 'hidden',
    boxShadow: theme.shadows[1],
  },
  headerContainer: {
    display: 'flex',
    width: '100%',
    alignItems: 'flex-end',

    marginBottom: theme.spacing(2),
  },
  headerTitle: {
    fontWeight: 600,
  },
  toolboxContainer: {
    marginLeft: 'auto',
  },
  contentContainer: {
    margin: theme.spacing(2),
    width: stylesConstants.contentContainerMinWidth,
  },
}));
